import { render } from "./ScenarioCompare.vue?vue&type=template&id=13b6c045&scoped=true"
import script from "./ScenarioCompare.vue?vue&type=script&lang=js"
export * from "./ScenarioCompare.vue?vue&type=script&lang=js"

import "./ScenarioCompare.vue?vue&type=style&index=0&id=13b6c045&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b6c045"]])

export default __exports__